<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ToastWithActions
      group="global"
      position="bottom-left"
      :close-button-props="{ 'aria-label': $t('dscl.notification.closeAlt') }"
    />
  </div>
</template>
